import axios from 'axios';
import { CLOUD9_API, MESSAGING } from '../constants';
import { getStoredTenant, isNativeApp } from '../../native/platform';
import { blockWhenSessionExpired, expireSessionOn401 } from './session';

// Function to get the incoming origin
const getIncomingOrigin = () => {
  // Native app: the page is served from localhost, so the tenant is the workspace the user picked.
  if (isNativeApp()) return getStoredTenant();
  const isProduction = process.env.NODE_ENV === 'production';
  if (isProduction) {
    const hostname = window.location.hostname;
    const parts = hostname.split('.');
    const index = parts.indexOf('admin');

    if (index === 1) {
      return parts[index - 1];
    } else {
      return ''; // No subdomain found
    }
  } else {
    return 'delivery'; // In development, always use 'delivery'
  }
};

export const incomingOrigin = getIncomingOrigin();

export const PrivateApiCall = axios.create({
  baseURL: CLOUD9_API,
});

PrivateApiCall.interceptors.request.use(
  (req) => {
    // Known-dead token: cancel here instead of sending (see ./session.js)
    blockWhenSessionExpired(req);
    const token = localStorage.getItem('access_token');
    req.headers['incoming-origin'] = incomingOrigin;
    if (token) {
      req.headers.Authorization = `Bearer ${token}`;
    }
    return req;
  },
  (err) => {
    throw err;
  }
);

// First 401 marks the whole session expired, so the rest of the burst is never sent.
PrivateApiCall.interceptors.response.use((res) => res, expireSessionOn401);

export const PublicApiCall = axios.create({
  baseURL: CLOUD9_API,
});

PublicApiCall.interceptors.request.use(
  (req) => {
    req.headers['incoming-origin'] = incomingOrigin;
    const token = localStorage.getItem('access_token');
    if (token) {
      req.headers.Authorization = `Bearer ${token}`;
    }
    return req;
  },
  (err) => {
    throw err;
  }
);

export const PrivateApiCallMessaging = axios.create({
  baseURL: MESSAGING,
});

PrivateApiCallMessaging.interceptors.request.use(
  (req) => {
    blockWhenSessionExpired(req);
    const token = localStorage.getItem('access_token');
    req.headers['incoming-origin'] = incomingOrigin;
    if (token) {
      req.headers.Authorization = `Bearer ${token}`;
    }
    return req;
  },
  (err) => {
    throw err;
  }
);

PrivateApiCallMessaging.interceptors.response.use(
  (res) => {
    return res;
  },
  (err) => expireSessionOn401(err)
);